import React from "react";

/**
 * Component to add Organization and Website structured data
 * This helps search engines understand the business better
 */
const StructuredData = () => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "On Beauty Aesthetics",
    url: "https://www.onbeautyaesthetics.com",
    logo: "https://www.onbeautyaesthetics.com/logo512.png",
    description:
      "Premium skincare products including creams, serums, lotions, body milk, and massage oils. Enhance your beauty with On Beauty Aesthetics.",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "Customer Service",
      availableLanguage: ["Albanian", "English"],
    },
    sameAs: [
      // Add your social media profiles here when available
      // "https://www.facebook.com/onbeautyaesthetics",
      // "https://www.instagram.com/onbeautyaesthetics",
    ],
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "On Beauty Aesthetics",
    url: "https://www.onbeautyaesthetics.com",
    description:
      "Premium skincare products including creams, serums, lotions, body milk, and massage oils. Enhance your beauty with On Beauty Aesthetics.",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate:
          "https://www.onbeautyaesthetics.com/shop?search={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(organizationSchema),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(websiteSchema),
        }}
      />
    </>
  );
};

export default StructuredData;
